<template>
    <div>
        <div id="recaptcha-widget"></div>
        <div v-if="renderError">Fail to load recaptcha</div>
    </div>
</template>

<script>
export default {
    created() {
        window.__recaptchaLoaded = () => this.recaptchaLoaded();
    },
    props: {
        value: { type: String }
    },
    data() {
        return { renderError: undefined };
    },
    mounted() {
        const id = 'recaptcha-script';
        if (!document.getElementById(id)) {
            const script = document.createElement('script');
            script.id = id;
            script.src = `https://www.google.com/recaptcha/api.js?onload=__recaptchaLoaded&render=explicit`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        } else {
            this.$nextTick(() => {
                this.recaptchaLoaded();
            });
        }
    },
    methods: {
        recaptchaLoaded() {
            try {
                this.widgetId = window.grecaptcha.render('recaptcha-widget', {
                    sitekey: this.$store.state.recaptchaSiteKey,
                    callback: resp => this.$emit('input', resp),
                    'expired-callback': () => this.$emit('input', undefined)
                });
            } catch (e) {
                this.renderError = e;
                /* eslint-disable no-console */
                console.error('render recaptcha error', e);
            }
        },
        reset() {
            if (this.widgetId === undefined) {
                return;
            }
            window.grecaptcha.reset(this.widgetId);
        }
    }
};
</script>
